module.exports = require("lodash/defaults");


//////////////////
// WEBPACK FOOTER
// external "lodash/defaults"
// module id = 37
// module chunks = 0